// useConnectivity — subscribe a component to the global connectivity status.
// Returns 'online' | 'reconnecting' | 'offline'. Backed by utils/connectivity.js
// (navigator.onLine + the shared Supabase realtime socket).

import { useSyncExternalStore } from 'react';
import {
  subscribeConnectivity,
  getConnectivityStatus,
} from '../utils/connectivity';

export function useConnectivity() {
  return useSyncExternalStore(
    subscribeConnectivity,
    getConnectivityStatus,
    getConnectivityStatus, // server snapshot — assume online during SSR/tests
  );
}
